export type CompanyContactStatus = 'active' | 'inactive' | 'archived';
export type CompanyContactType = 'manual' | 'lead' | 'customer' | 'partner';
export type CompanyPreferredContactMethod = 'email' | 'phone' | 'none';

export interface CompanyContact {
  id: string;
  lead_id: string | null;
  organization_name: string | null;
  name: string;
  email: string | null;
  phone: string | null;
  role: string | null;
  contact_type: CompanyContactType;
  status: CompanyContactStatus;
  preferred_contact_method: CompanyPreferredContactMethod;
  tags: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string | null;
  archived_at: string | null;
  source: 'contact' | 'lead';
  lead_status?: string | null;
}

export function companyContactStatusTone(status: CompanyContactStatus): 'ok' | 'warn' | 'info' {
  if (status === 'active') return 'ok';
  if (status === 'inactive') return 'warn';
  return 'info';
}

export function companyContactStatusLabel(status: string | null | undefined): string {
  if (status === 'active') return 'Active';
  if (status === 'inactive') return 'Inactive';
  if (status === 'archived') return 'Archived';
  return 'Active';
}

export function companyContactTypeLabel(type: string | null | undefined): string {
  if (type === 'lead') return 'Lead';
  if (type === 'customer') return 'Customer';
  if (type === 'partner') return 'Partner';
  return 'Manual';
}

export function splitTags(value: string | null | undefined): string[] {
  return (value ?? '')
    .split(',')
    .map((tag) => tag.trim())
    .filter(Boolean);
}
